export const useFileAccessWorker = async () => {
    const publicPath = typeof process == "undefined" ? "" : process?.env?.VUE_APP_PUBLIC_PATH ?? "";
    let url = `${publicPath}/_inc/js/fs-write-worker.js`;
    if (publicPath != "") {
        url = URL.createObjectURL(new Blob([`importScripts(${JSON.stringify(url.toString())});`], {
            type: "application/javascript"
        }));
    }
    let fileAccessWorker = window.Worker ? new Worker(url) : undefined;
    let supported = false;
    let testMessageResolver;
    let sizeMessageResolver;
    let fileWriteResolver;
    const fileReadResolvers = new Map();
    let fileCloseResolver;
    const writerMessageResponse = async () => {
        return new Promise((resolve) => {
            fileWriteResolver = resolve;
        });
    };
    const sizeMessageResponse = async () => {
        return new Promise((resolve) => {
            sizeMessageResolver = resolve;
        });
    };
    const readerMessageResponse = async (offset) => {
        return new Promise((resolve) => {
            fileReadResolvers.set(offset, resolve);
        });
    };
    const closeMessageResponse = async () => {
        return new Promise((resolve) => {
            fileCloseResolver = resolve;
        });
    };
    if (fileAccessWorker) {
        fileAccessWorker.onmessage = (e) => {
            const data = e.data;
            if (data.type === "read") {
                if (data.offset != undefined && data.data) {
                    fileReadResolvers.get(data.offset)?.(data.data);
                }
            }
            else if (data.type === "close") {
                fileCloseResolver(true);
            }
            else if (data.type === "write") {
                fileWriteResolver(data.size ?? 0);
            }
            else if (data.type === "size") {
                sizeMessageResolver(data.size ?? 0);
            }
            else if (data.type === "test") {
                testMessageResolver((data.size ?? 0) > 0);
            }
        };
        try {
            fileAccessWorker?.postMessage({ action: "test" });
            supported = await new Promise((resolve, reject) => {
                testMessageResolver = resolve;
                setTimeout(() => {
                    reject(false);
                }, 2000);
            });
        }
        catch (e) {
            // Unresponsive worker - possibly failed to load.
            fileAccessWorker = undefined;
        }
    }
    return {
        fileAccessWorker,
        readerMessageResponse,
        closeMessageResponse,
        writerMessageResponse,
        sizeMessageResponse,
        supported
    };
};
